export const BASE_URL_AUTH_API = process.env.REACT_APP_BASE_URL_AUTH_API as string;
export const URL_LOGIN = "/login";
export const URL_REGISTER = "/login/register";
export const URL_FORGOT_PASSWORD = "/login/forgot-password";
export const URL_RESET_PASSWORD = "/login/reset-password";
export const URL_EMAIL_VERIFICATION = "/login/email-verification";
export const SYSTEM_TENANT_ID = process.env.REACT_APP_SYSTEM_TENANT_ID as string;
export const GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID as string;
